import { render, staticRenderFns } from "./locomotive-washing.vue?vue&type=template&id=1b60298e&scoped=true"
import script from "./locomotive-washing.vue?vue&type=script&lang=js"
export * from "./locomotive-washing.vue?vue&type=script&lang=js"
import style0 from "./locomotive-washing.vue?vue&type=style&index=0&id=1b60298e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b60298e",
  null
  
)

export default component.exports